<template>
  <div class="recording-position-tracker"></div>
</template>

<script>
  export default {
    name: "RecordingPositionTracker",

    props: {
      updateInterval: {
        type: Number,
        default: 0
      }
    },

    data() {
      return {
        nextUpdate: 0,
        lastPosition: 0
      };
    },

    computed: {
      videoPosition() {
        return this.$store.state.recording && this.$store.state.recording.position;
      }
    },

    watch: {
      updateInterval: {
        immediate: true, // to handle static values like :updateInterval="5"
        handler(newValue) {
          if (newValue) {
            this.nextUpdate = newValue;
          }
        }
      },

      videoPosition(newPosition) {
        if (!newPosition || !this.nextUpdate) {
          return;
        }

        if (newPosition >= this.nextUpdate || newPosition < this.lastPosition) {
          this.$emit('elapsed', {elapsed: newPosition});
        }

        this.lastPosition = newPosition;

        // could change if they seek backward
        const intervals = Math.floor(newPosition / this.updateInterval) + 1;
        this.nextUpdate = intervals * this.updateInterval;
      }
    }
  }
</script>

<style scoped>

</style>
